var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    fill: "white",
    viewBox: "0.5 0 24 24",
    enableBackground: "new 0.5 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4475__x28_Stroke_x29_",
    d: "M16.822,1.786H23.5v20.428h-6.678V1.786z M19.179,4.143v15.714h1.965V4.143H19.179z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4477__x28_Stroke_x29_",
    d: "M9.358,6.893h6.678v15.321H9.358V6.893z M11.715,9.25v10.607h1.965V9.25H11.715z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4478__x28_Stroke_x29_",
    d: "M1.5,12.786h6.679v9.428H1.5V12.786z M3.857,15.143v4.715h1.964v-4.715H3.857z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.761862c2a2d205c92225fc934ba1d25e.svg";
export { ForwardRef as ReactComponent };